import {
    ChangeDetectionStrategy,
    Component, computed, effect, inject,
    signal,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { ISbStoryData } from 'storyblok-js-client';
import { StoryblokService } from '@seven1/angular-storyblok/api';
import { S1Layout } from '@seven1/model';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    imports: [CmsComponent, CmsComponent],
    templateUrl: './cms.page.html',
    styleUrl: './cms.page.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmsPage {
    private _route = inject(ActivatedRoute);
    private _service = inject(StoryblokService);
    private _data = toSignal(this._route.data);

    public story = signal<ISbStoryData | undefined>(undefined);
    public layout =computed<S1Layout | null>(() => {
        const data = this._data();
        if (data && data['layout']) {
            return data['layout'];
        }
        return null;
    });

    constructor() {
        effect(() => {
            const data = this._data();
            if (data && data['story']) {
                this.story.set(data['story']);
                this._service.initEditor((d) => {
                    if (d && (d as Data)['story']) {
                        this.story.set((d as Data)['story']);
                    }
                });
            }
        });
    }
}
